import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useOrganization } from "@/contexts/OrganizationContext";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";

interface OrgRestrictedRouteProps {
  children: ReactNode;
  allowedOrgIds: string[];
}

/** Restringe acesso a organizações específicas. */
export function OrgRestrictedRoute({ children, allowedOrgIds }: OrgRestrictedRouteProps) {
  const { currentOrg, loading } = useOrganization();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <span className="ml-2 text-muted-foreground">Verificando permissões...</span>
      </div>
    );
  }

  if (!currentOrg || !allowedOrgIds.includes(currentOrg.id)) {
    return (
      <div className="container mx-auto px-6 py-8">
        <Alert variant="destructive">
          <ShieldX className="h-4 w-4" />
          <AlertDescription>
            Acesso negado. Esta página não está disponível para a sua organização.
          </AlertDescription>
        </Alert>
        <Button
          variant="outline"
          className="mt-4"
          onClick={() => navigate("/dashboard")}
        >
          Voltar ao Dashboard
        </Button>
      </div>
    );
  }

  return <>{children}</>;
}
